import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero, Verticales, Cifras, Process, FAQ, FinalCTA } from "@/components/landing/Sections";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* La cabecera flota sobre el hero a sangre, no lo empuja hacia abajo. */}
      <SiteHeader overlay />
      <main>
        <Hero />
        <Verticales />
        <Cifras />
        <Process />
        <FAQ />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
